import { call } from 'redux-saga/effects'

import { trackSF } from '../providers'
import { NOT_AVAILABLE } from '../../../../helpers/const'

function* toggleView(action) {
  const { params } = action.payload
  const {
    id, title, position, view,
  } = params

  const productTitle = title || NOT_AVAILABLE

  // Shopfully
  yield call(trackSF, {
    s2s_ea: 'tv',
    s2s_ec: 'c',
    s2s_el: view,
    s2s_pos: position,
    s2s_iid: id,
    s2s_title: productTitle,
  })
}

export default toggleView
